import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

import useCollapseDrawer from '../../hooks/useCollapseDrawer';
import { HEADER } from '../../config';
import DashboardHeader from './header';
import usePage from 'src/hooks/usePage';
import { StackColumn } from 'src/components';
import { Footer } from './Footer';
import { Sidebar } from '../navigation/sidebar/sidebar';

// ----------------------------------------------------------------------

type MainStyleProps = {
  collapseClick: boolean;
  alert: string;
};

const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseClick',
})<MainStyleProps>(({ collapseClick, theme, alert }) => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  // MOBILE_HEIGHT & DASHBOARD_DESKTOP_HEIGHT need to be increased by subscription top Alert component height
  paddingTop: HEADER.MOBILE_HEIGHT + (alert === 'true' ? HEADER.ALERT_HEIGHT : 0),
  paddingLeft: 16,
  minHeight: '100vh',
  paddingRight: 16,
  [theme.breakpoints.up('lg')]: {
    paddingTop: HEADER.MOBILE_HEIGHT + (alert === 'true' ? HEADER.ALERT_HEIGHT : 0),
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.shorter,
    }),
  },
  backgroundColor: '#F4F6F8',
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { collapseClick, isCollapse } = useCollapseDrawer();
  const { isOpenAlert } = usePage();

  const [open, setOpen] = useState(false);

  return (
    <MainStyle collapseClick={collapseClick} alert={isOpenAlert?.toString()}>
      <DashboardHeader isCollapse={isCollapse} onOpenSidebar={() => setOpen(true)} />

      {/* SideBar (mobile) */}
      <Sidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

      <StackColumn gap={10} justifyContent="space-between" flex={1}>
        <Box display='flex' flex={1}>
          <Outlet />
        </Box>

        <Footer />
      </StackColumn>
    </MainStyle>
  );
}
